<template>
  <v-dialog v-model="data.open" max-width="600px" persistent>
    <v-card>
      <v-card-title>
        <span class="headline">{{ $t(data.title) }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <formComponent
            ref="formComponent"
            :form="instructionForm"
            v-model="instructionForm.formData"
          />
        </v-container>
      </v-card-text>

      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="grey" outlined @click="closeform">{{
          $t("general.back")
        }}</v-btn>
        <v-btn v-if="!isReadOnlyUser" color="primary" @click="saveForm" data-cy="saveEvent">
          {{ $t("general.saveChanges") }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import formComponent from "../../_utils/formComponent/formComponent.vue";
import { getUniqueId } from "../../api/api";
export default {
  components: { formComponent },
  props: ["data", "item"],
  data: () => ({
    instructionForm: {
      formData: {
        title: "",
      },
      form: [
        [
          {
            cols: 12,
            sm: 12,
            md: 12,
            class: "py-0 mt-6",
            id: getUniqueId(),
            componentName: "instructionTitle",
            config: {},
          },
        ],
      ],
    },
  }),
  watch: {
    "data.open"(open) {
      if (open) this.prefill();
    },
  },
  methods: {
    prefill() {
      this.instructionForm.formData = {
        title: this.item?.title || "",
      };
    },
    closeform() {
      this.data.open = false;
    },
    saveForm() {
      if (!this.$refs.formComponent.validateAllFields()) return;

      //only the edited field is sent, so the backend does not move the stored
      //file because it sees a name or filetype in the body
      this.$store
        .dispatch("updateInstruction", {
          id: this.item?.id || this.item?._id,
          title: this.instructionForm.formData.title?.trim() || null,
        })
        .then(() => {
          this.closeform();
          this.$emit("reloadData");
        });
    },
  },
};
</script>
